import { render, staticRenderFns } from "./draw3DPieCanvas.vue?vue&type=template&id=7b1d3ec1&scoped=true"
import script from "./draw3DPieCanvas.vue?vue&type=script&lang=js"
export * from "./draw3DPieCanvas.vue?vue&type=script&lang=js"
import style0 from "./draw3DPieCanvas.vue?vue&type=style&index=0&id=7b1d3ec1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1d3ec1",
  null
  
)

export default component.exports